<template>
  <div class="page-content">
    <page-template
      ref="memberCategoryTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
    <el-dialog :title="selectRow.id ? '编辑礼品' : '添加礼品'" :visible.sync="dialogVisibility" width="300px" height="500px"
               @close="closeDialogAdd" :close-on-click-modal="false" class="add-form">
      <div class="form-flex">
        <el-form ref="addForm" :model="addForm" :rules="formRule" class="steps-form" label-width="100px"
                 :show-message="true">
          <div>
            <el-col :span="24">
              <el-form-item label='礼品类型' prop="type">
                <el-radio-group
                  v-model="addForm.type"
                  disabled
                >
                  <el-radio
                    v-for="(item,index) in typeList"
                    :key="index"
                    :label="item.id"
                  >{{ item.label }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" hidden="true">
              <el-form-item label='礼品' prop="barCode">
                <el-input v-model.trim="addForm.barCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label='礼品' prop="name">
                <el-input v-model.trim="addForm.name"
                          :disabled="true"></el-input>
                <el-button type="primary" @click="selectGoods">选择</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label='可兑换总数' prop="startQuantity">
                <el-input-number v-model.trim="addForm.startQuantity" :precision="0" placeholder='请输入可兑换总数' :max="99999"
                                 :min="1"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label='兑换积分值' prop="needIntegral">
                <el-input-number v-model.trim="addForm.needIntegral" :max="999999" :precision="0" :min="1"
                                 placeholder='请输入兑换积分值'></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label='门店' prop="storeType">
                <el-radio-group
                  v-model="addForm.storeType"
                  @change="clickStore"
                >
                  <el-radio
                    v-for="(item,index) in storeTypeList"
                    :key="index"
                    :label="item.id"
                  >{{ item.label }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-show="storeShow">
              <el-form-item label='选择门店' prop="storeIdList">
                <el-select multiple collapse-tags
                           v-model="addForm.storeIdList">
                  <el-option
                    v-for="(item,index) of storeList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label='有效期' prop="startDttm">
                <el-date-picker
                  v-model="addForm.startDttm"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  default-time="00:00:00">
                </el-date-picker>
                &nbsp;至&nbsp;
                <el-date-picker
                  v-model="addForm.endDttm"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  default-time="23:59:59">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </div>
        </el-form>
        <div class="footerBtn">
          <el-button type="primary" @click="submitData()">保存</el-button>
          <el-button type="default" @click="reset()">重置</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="商品列表" :visible.sync="listShow" width="1200px" height="800"
               :close-on-click-modal="false">
      <good-list
        v-if="listShow"
        ref="goodsListOperation"
        @rowCheck="rowCheck"
        :isSelect="goodListSelect"
        :otherParam="otherParam"
        :selectUrl="selectUrl"
        :listTableData="listTableData"
      ></good-list>
    </el-dialog>
    <el-dialog title="分店" :visible.sync="allStoreShow" width="300px" height="1000px" :close-on-click-modal="false">
      <list-template :tableOptions="storeColumns" :tableData="storeTableData"
                     ref="storeListOperation">
      </list-template>
    </el-dialog>
  </div>
</template>

<script>
import pageTemplate from "@/components/template/pageTemplate";
import api from "@/config/api";
import userPower from "@/mixin/userPower";
import goodList from '@/components/business/goodList';
import listTemplate from '@/components/template/listTemplate';


export default {
  mixins: [userPower],
  components: {
    pageTemplate,
    goodList,
    listTemplate
  },
  data() {
    return {
      loading: false,
      storeShow: false,
      allStoreShow: false,
      selectUrl: {url: api.warehouse.warehouseGoods},
      listShow: false,
      goodListSelect: false,
      otherParam: {statusList: [10, 20], isOpenCombination: 2},
      listTableData: [],
      selectRow: {},
      typeList: [
        {label: '实物', id: 10},
        {label: '优惠卷', id: 20},
      ],
      storeTypeList: [
        {label: '全部门店', id: 20},
        {label: '指定门店', id: 10},
      ],
      storeList: [],
      isDisabled: false,
      addForm: {
        type: 10,
        name: '',
        barCode: '',
        startQuantity: '',
        needIntegral: '',
        storeType: 20,
        storeIdList: [],
        startDttm: '',
        endDttm: '',
      },
      formRule: {
        name: [{required: true, message: '商品名称不能为空', trigger: 'blur'}],
        startQuantity: [{required: true, message: '可兑换总数不能为空', trigger: 'blur'}],
        needIntegral: [{required: true, message: '兑换积分值不能为空', trigger: 'blur'}],
        startDttm: [{required: true, message: '日期不能为空', trigger: 'blur'}],
        storeIdList: [{required: true, message: '门店不能为空', trigger: 'blur'}],
      },
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: '礼品编码或名称',
            prop: 'otherName',
            type: 'input',
            placeholder: '请输入礼品编码或名称',
            labelWidth: '110'
          },
        ],
      },

      // 更多功能
      toolConfig: [
        {
          label: "新增",
          code: "insert",
          callback: this.insert,
          filter: () => {
            return this.$utils.getSysUser().storeId ? false : true
          }
        },
        {
          label: "编辑",
          type: this.$utils.buttonType.tableOperate,
          code: "update",
          filter: () => {
            return this.$utils.getSysUser().storeId ? false : true
          },
          callback: this.update,
        },
        {
          label: "删除",
          code: "delete",
          type: this.$utils.buttonType.tableOperate,
          filter: () => {
            return this.$utils.getSysUser().storeId ? false : true
          }
        },
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          {label: '礼品编码', prop: 'barCode', width: '190', align: 'center'},
          {label: '礼品名称', prop: 'goodsName', width: '140', align: 'center'},
          {
            label: '自编码',
            prop: 'artNo',
            width: '140',
            align: 'center',
          },
          {
            label: '礼品类型',
            prop: 'type',
            width: '100',
            align: 'center',
            enumData: this.$utils.getCacheStatus('mbIntegralGift.type')
          },
          {label: '可兑换总数', prop: 'startQuantity', width: '100', align: 'center'},
          {label: '兑换所需积分', prop: 'needIntegral', width: '120', align: 'center'},
          {
            label: '分店',
            prop: 'storeTypeDesc',
            width: '100',
            align: 'center',
            callback: this.showStoreList,
          },
          {label: '已兑换数量', prop: 'endQuantity', width: '100', align: 'center'},
          {label: '开始日期', prop: 'startDttm', width: '135', align: 'center'},
          {label: '结束日期', prop: 'endDttm', width: '135', align: 'center'},
        ],
        url: api.member.mbIntegralGift
      },
      // 分店数据
      storeTableData: [],
      storeColumns: {
        disabled: false,
        indexShow: true, // 是否显示索引
        columns: [
          {
            label: '编码',
            prop: 'code',
            width: '200'
          },
          {
            label: '名称',
            prop: 'name',
            width: '200'
          },
        ]
      },
    };
  },
  created() {
    this.getStoreOptions();
  },
  methods: {
    // 门店
    getStoreOptions() {
      this.$axios.fetchPost(api.system.seStore + '/list', {}).then(res => {
        // res.data.unshift({name:'全部门店',id:null})
        if (res.code === 200) {
          res.data.unshift({name: '总部', id: -1})
          this.storeList = res.data
        }
      });
    },
    submitData() {
      let paramFlag = this.checkParams();
      if (paramFlag) {
        const loading = this.$loading({
          lock: true,
          text: '提交中，请稍候...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        if (this.selectRow.id) {
          this.$axios.fetchPut(api.member.mbIntegralGift, this.addForm).then(data => {
            if (data.code === 200) {
              this.selectRow = {};
              this.dialogVisibility = false;
              this.$refs['memberCategoryTemplate'].getData();
              this.$notify({
                type: "success",
                title: '编辑操作',
                message: '成功',
                showClose: false,
              });
            } else {
              this.$notify({
                type: "error",
                title: '编辑操作',
                message: '失败',
                showClose: false,
              });
            }
          }).finally(() => {
            this.closeDialogAdd();
            loading.close();
          });
        } else {
          this.$axios.fetchPost(api.member.mbIntegralGift, this.addForm).then(data => {
            if (data.code === 200) {
              this.selectRow = {};
              this.dialogVisibility = false;
              this.$refs['memberCategoryTemplate'].getData();
              this.$notify({
                type: "success",
                title: '新增操作',
                message: '成功',
                showClose: false,
              });
            } else {
              this.$notify({
                type: "error",
                title: '新增操作',
                message: '失败',
                showClose: false,
              });
            }
          }).finally(() => {
            this.closeDialogAdd();
            loading.close();
          });
        }
      }
    },
    // 编辑
    update(row) {
      Object.assign(this.addForm, row);
      this.addForm.name = row.goodsName + '(' + row.barCode + ')';
      if (this.addForm.storeType === 10) {
        this.addForm.storeIdList = this.addForm.storeIds.split(',');
      }
      this.clickStore(this.addForm.storeType);
      this.selectRow = row;
      this.dialogVisibility = true;
    },

    showStoreList(row) {
      console.log(row);
      let params = {};
      if (row.storeType === 10) {
        params.ids = row.storeIds.split(',');
      }
      let obj = [{code: '0000', name: '总部'}];
      this.$axios.fetchPost(api.system.seStore + '/list', params).then(res => {
        if (res.code === 200) {
          if (row.storeType === 20) {
            this.storeTableData = [...obj, ...res.data];
          } else {
            if (row.storeIds.indexOf("-1") !== -1) {
              this.storeTableData = [...obj, ...res.data];
            } else {
              this.storeTableData = res.data;
            }
          }
          this.allStoreShow = true;
        }
      });
    },
    valueChange(column) {
      column.change && column.change(this.formModel);
    },
    insert() {
      this.dialogVisibility = true;
    },
    selectGoods() {
      this.listShow = true;
    },
    // 选择某行数据
    rowCheck(row) {
      this.addForm.name = row.goodsName + '(' + row.barCode + ')';
      this.addForm.barCode = row.barCode;
      this.listShow = false;
    },
    clickStore(param) {
      if (param === 20) {
        this.addForm.storeIdList = [];
        this.formRule.storeIdList[0].required = false;
        this.storeShow = false;
      } else {
        this.formRule.storeIdList[0].required = true;
        this.storeShow = true;
      }
    },
    closeDialogAdd() {
      this.selectRow = {};
      this.addForm = {
        type: 10,
        name: '',
        barCode: '',
        startQuantity: '',
        needIntegral: '',
        storeType: 20,
        storeIdList: [],
        startDttm: '',
        endDttm: '',
      };
    },
    checkParams() {
      if (this.addForm.barCode === '' || this.addForm.barCode === null) {
        this.$message.warning("礼品不能为空");
        return false;
      }
      if (this.addForm.storeType === 10) {
        if (this.addForm.storeIdList.length === 0) {
          this.$message.warning("门店不能为空");
          return false;
        }
      }
      if (this.addForm.startDttm === '' || this.addForm.startDttm === null) {
        this.$message.warning("开始时间不能为空");
        return false;
      }
      if (this.addForm.endDttm === '' || this.addForm.endDttm === null) {
        this.$message.warning("结束时间不能为空");
        return false;
      }
      return true;
    }
  },
};
</script>

<style scoped>
.add-form >>> .el-dialog {
  max-height: 90vh;
  top: 30%;
  left: 50%;
  margin: 0 !important;
  transform: translate(-50%, -50%);
}


.add-form >>> .el-dialog__body {
  max-height: unset;
}

.add-form >>> .el-form-item {
  min-height: 35px;
}

>>> .el-input__inner {
  height: 30px;
}

.add-form >>> .el-form-item .el-cascader {
  line-height: unset;
}

.steps-form {
  padding: 0 50px;
  /*min-height: 500px*/
}

.steps-form >>> .el-input-number .el-input__inner {
  padding: 0 10px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/page/member/integral/Gift.vue